<script>
export default {
  name: 'customers.grid-card',
  props: { customer: { type: Object, default: () => {} } }
}
</script>
<template>
  <b-card no-body class="shadow-sm border border-light">
    <router-link
      :to="{
        name: 'sales.customers.view',
        params: { id: customer.id }
      }"
    >
      <b-card-header header-bg-variant="white" class="px-3 pt-3 pointer">
        <div class="d-flex justify-content-between align-items-center">
          <b-card-title class="text-truncate">
            {{ customer.legal_name }}
          </b-card-title>
        </div>

        <p class="mt-2 mb-1 text-muted">N° {{ customer.customer_number }}</p>
        <p class="my-0 text-muted">
          VAT N° {{ customer.vat_number }}
          <template v-if="customer.vat_number_valid"
            ><i
              class="bx bx-check-shield text-success"
              :id="`tt-vatnr-valid-${customer.id}`"
            ></i>
            <b-tooltip
              :target="`tt-vatnr-valid-${customer.id}`"
              triggers="hover"
              v-if="customer.vat_number_last_checked_at"
            >
              Verified on
              {{
                customer.vat_number_last_checked_at
                  | moment('DD/MM/YYYY - HH:mm')
              }}
            </b-tooltip>
          </template>
          <template v-else
            ><i
              class="bx bx-x-circle text-danger"
              :id="`tt-vatnr-invalid-${customer.id}`"
            ></i
            ><b-tooltip
              :target="`tt-vatnr-invalid-${customer.id}`"
              triggers="hover"
              v-if="!customer.vat_number_last_checked_at"
            >
              Not verified
            </b-tooltip></template
          >
        </p>
      </b-card-header>
    </router-link>
    <b-card-footer footer-bg-variant="transparent" class="border-top p-2">
      <div class="d-flex justify-content-start">
        <div class="flex-fill">
          <router-link
            v-b-tooltip.hover.top
            title="Overview"
            :to="{
              name: 'sales.customers.view.overview',
              params: { id: customer.id }
            }"
            ><i class="bx bx-bar-chart p-2"></i>
          </router-link>
          <router-link
            v-b-tooltip.hover.top
            title="Orders"
            :to="{
              name: 'sales.customers.view.addresses',
              params: { id: customer.id }
            }"
            ><i class="bx bx-basket p-2"></i>
          </router-link>
          <router-link
            v-b-tooltip.hover.top
            title="Deliveries"
            :to="{
              name: 'sales.customers.view.addresses',
              params: { id: customer.id }
            }"
            ><i class="bx bx-package p-2"></i>
          </router-link>
          <router-link
            v-b-tooltip.hover.top
            title="Invoices"
            :to="{
              name: 'sales.customers.view.addresses',
              params: { id: customer.id }
            }"
            ><i class="bx bx-receipt p-2"></i>
          </router-link>
        </div>
        <div class="flex-fill text-right">
          <router-link
            v-b-tooltip.hover.top
            title="Settings"
            :to="{
              name: 'sales.customers.settings',
              params: { id: customer.id }
            }"
            ><i class="bx bx-cog p-2"></i>
          </router-link>
        </div>
      </div>
    </b-card-footer>
  </b-card>
</template>
